import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Card,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Icon,
  AppBar,
  Toolbar,
  Grid,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Cards from "./NewOrderCard";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { clearStatusFilter, setHasFilter, setSavedStatus } from "app/store/statusSlice";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { has } from "lodash";
import { AgGridReact } from "ag-grid-react";
import discountIcon from 'src/assets/tag.png';
import Draggable from 'react-draggable';
import { toast } from "react-toastify";
  import { useMediaQuery } from "@mui/material";

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress":
    {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: "19px",
      lineHeight: "19px",
      padding: "0px 10px",
      marginTop: "1px",
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const CreateNewType = (props) => {
  const navigate = useNavigate();
  const handleCreateNewType = () => {
    navigate("/order/create-order");
  };
  return (
    <>
      <Tooltip title={"Create a New Type"}>
        <IconButton onClick={handleCreateNewType}>
          <FuseSvgIcon size={14} color="action">
            heroicons-solid:color-swatch
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
    </>
  );
};

const initialValues = {
  customerId: null,
  showroomId: null,
  createdBy: "",
};

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
const getMyOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getMyOrders}`;
const getNewOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getNewOrderList}`;
const activeCompaniesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.activeCompanies}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const usersUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    const date = new Date(dateAsString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    if (formattedDate == null) return -1;
    var dateParts = formattedDate.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  maxValidYear: new Date().getFullYear(),
};

const NewOrderList = (props) => {
  const theme = useTheme();

const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [error, setError] = useState()
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [orderStatus, setOrderStatus] = useState("NEW");
  const [filter, setFilter] = useState(initialValues);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [createdUser, setCreatedUser] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [createdDateFrom, setCreatedDateFrom] = useState(null)
  const [createdDateTo, setCreatedDateTo] = useState(null)
  const [processedDateFrom, setProcessedDateFrom] = useState(null)
  const [processedDateTo, setProcessedDateTo] = useState(null)
  const [orderCount, setOrderCount] = useState(null)
  const [hasSearch, setHasSearch] = useState(false);
  const [openAssignerForm, setOpenAssignerForm] = useState(false);
  const [user, setUser] = useState();
  const [assignedTo, setAssignedTo] = useState();
  const dispatch = useDispatch();
  const savedStatus = useSelector((state) => state.status.status);
  const hasFilter = useSelector((state) => state.status.hasFilter);
  const token = localStorage && localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const stateRef = useRef();
  const saveGridStateName = 'newOrderList';

  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    []
  );
const selectStyles = useMemo(() => {
  const base = customStyles();
  return {
    ...base,
    menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
    menu: (styles) => ({
      ...(base.menu ? base.menu(styles) : styles),
      zIndex: 9999,
    }),
    option: (styles, state) => ({
      ...(base.option ? base.option(styles, state) : styles),
      whiteSpace: "normal",
      wordBreak: "break-word",
    }),
  };
}, []);
  const specialDiscountIcon = (params) => {
    if (!params?.data) return null;
    const { commissionName, specialDiscountRequested } = params?.data;
    return (
      <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {commissionName}
        {specialDiscountRequested && (
          <img src={discountIcon} width="20px" height="20px" style={{ marginBottom: "0px", position: "absolute", right: "2px", top: "2px", marginRight: "8px" }} />
        )}
      </span>
    );
  };

  const getColumnDefs = (orderStatus) => {
    const baseColumns = [
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        pinned: isMobile ? false : "left",
        minWidth: 50,
        maxWidth: 50,
        editable: false,
      },
      {
        headerName: "Sr No.",
        valueGetter: "node.rowIndex + 1",
        minWidth: 60,
        maxWidth: 60,
        pinned: isMobile ? false : "left",
        filter: false,
        resizable: true,
        editable: false,
      },
      {
        field: "orderStatus",
        cellEditor: "agRichSelectCellEditor",
        minWidth: 100,
        maxWidth: 100,
        resizable: true,
      },
      {
        field: "abNumber",
        headerName: "AB Number",
        enableRowGroup: true,
        minWidth: 100,
        resizable: true,
      },
      {
        field: "commissionName",
        headerName: "Commission Name",
        enableRowGroup: true,
        minWidth: 200,
        resizable: true,
        cellRenderer: specialDiscountIcon,
      },
      {
        field: "documentType",
        headerName: "Type",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "customerName",
        headerName: "Customer",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "projectName",
        headerName: "Project Name",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "phaseName",
        headerName: "Project Phase",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "showroomName",
        headerName: "Showroom",
        enableRowGroup: true,
        minWidth: 50,
        filter: "agTextColumnFilter",
        resizable: true,
      },
      {
        field: "createdByUser",
        headerName: "Created By",
        enableRowGroup: true,
        minWidth: 50,
        filter: "agTextColumnFilter",
        resizable: true,
      },
      {
        field: "vendorName",
        headerName: "Product",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "orderCategory",
        headerName: "Category",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "assignedTo",
        headerName: "Assigned",
        enableRowGroup: true,
        minWidth: 50,
        resizable: true,
      },
      {
        field: "createdDate",
        headerName: "Created",
        enableRowGroup: true,
        filter: "agDateColumnFilter",
        minWidth: 50,
        filterParams,
        cellRenderer: handleDateFormat,
        resizable: true,
      },
    ];

    if (orderStatus === "COMPLETED") {
      baseColumns.push({
        field: "orderPlacedDate",
        headerName: "Processed",
        enableRowGroup: true,
        filter: "agDateColumnFilter",
        filterParams,
        cellRenderer: handleDateFormat,
        resizable: true,
      });
    }

    return baseColumns;
  };

  const [columnDefs, setColumnDefs] = useState(getColumnDefs(orderStatus));
  useEffect(() => {
    setColumnDefs(getColumnDefs(orderStatus));
  }, [orderStatus, isMobile]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 150,
      filter: true,
      floatingFilter: true,
      resizable: true,
      enableRowGroup: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    };
  }, []);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);

  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(data.screenState.columnGroupState);
        }
      } catch (err) {
        console.error('Failed to load grid state:', err);
      }
    }
  };

  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(`gridState-${saveGridStateName}`, JSON.stringify(stateRef.current));
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);

  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

  const fetchOrders = async () => {
    gridRef.current?.api?.showLoadingOverlay();
    try {
      const list = await OAuthService.getPostList(getNewOrderUrl, savedStatus);
      const data = list.data;
      const filterUsers = data.orders.map((user) => user.createdByUser);
      setRowData(data.orders);
      setCreatedUser(filterUsers);
      setOrderCount(data.count);
      gridRef.current?.api?.hideOverlay();
    } catch (error) {
      gridRef.current?.api?.hideOverlay();
      console.log(error.message);
      setError(error.message);
    }
  };
  const userData = async () => {
    try {
      const list = await OAuthService.getList(usersUrl + `?sort=firstName,asc&size=1000`);
      const users = list.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        return data;
      });
      const roleUsers = users.filter(
        (user) =>
          user.roles.includes("ROLE_DESIGNER") ||
          user.roles.includes("ROLE_DESGNSTHEAD") ||
          user.roles.includes("ROLE_ORDERPRO") ||
          user.roles.includes("ROLE_SOPDIR")
      );
      setUser(
        roleUsers.map((item) => ({
          value: item.email,
          label: `${item.firstName} ${item.lastName}`,
        }))
      );
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const getUsers = async () => {
    try {
      const list = await OAuthService.getList(usersUrl + '?size=1000');
      const users = list?.data?._embedded?.users;
      setUserOptions(
        users.map((user) => {
          return {
            value: user.email,
            label: `${user.firstName} ${user.lastName}`,
          };
        })
      );
    } catch (error) {
      console.log(error.message);
      setError(error.message);
    }
  };

  // FIX 1: Run these only ONCE on mount
  useEffect(() => {
    getCustomer();
    userData();
    getUsers(); // Moved here so it doesn't loop
  }, []);

  // FIX 2: Simplified order fetching logic
  useEffect(() => {
    if (!hasSearch) {
      fetchOrders();
    }
  }, [orderStatus, hasFilter]);

  const getCustomer = async () => {
    try {
      const list = await OAuthService.getList(
        companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`
      );
      let companies = list.data?._embedded?.companies;
      companies = companies.map((company) => {
        return {
          value: company.id,
          label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
        };
      });
      companies = [{ value: "ALL", label: "ALL" }, ...companies];
      setCustomerOptions(companies);
    } catch (error) {
      console.log(error.message);
      setError(error.message);
    }
  };

  const getShowroom = async () => {
    try {
      if (Number(filter.customerId)) {
        const showroomByCompanyUrl = `${companiesUrl}/${filter.customerId}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
          };
        });
        setShowroomOptions(showrooms);
      } else {
        setShowroomOptions([]);
      }
    } catch (error) {
      toast.error("Showroom data not available");
      console.log(error.message);
      setError(error.message);
    }
  };

  useEffect(() => {
    if (filter.customerId) {
      getShowroom();
    }
  }, [filter.customerId]);

  const handleSelectChange = (data, key) => {
    if (key === "customerId") {
      const selectedValue = data ? data.value : null;
      if (selectedValue === "ALL") {
        setFilter({
          ...filter,
          customerId: "ALL",
          showroomId: "",
        });
      } else {
        setFilter({
          ...filter,
          customerId: selectedValue,
          showroomId: null,
        });
      }
      return;
    }
    setFilter({
      ...filter,
      [key]: data ? data.value : null,
    });
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onSortRefresh = (params) => {
    params.api.refreshCells();
  };

  const getRowStyle = useCallback((params) => {
    if (params.data && params.data.orderStatus === "HOLD") {
      return {
        background: theme.palette.warning.main,
        color: theme.palette.common.white,
      };
    }
    return null;
  }, []);

  const onRowDoubleClicked = (params) => {
    const filename = params.data.id;
    navigate("/order/order-details/" + filename);
  };

  const handleCreateOrder = () => {
    navigate("/order/create-order/");
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "NewOrder.xlsx",
      sheetName: "New Order",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handleDefaultGridState = () => {
    if (!gridRef.current) return;
    gridRef.current.api.setFilterModel(null);
    gridRef.current.columnApi.resetColumnState();
  };

  const handleAdvanceSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleBack = () => {
    navigate("/order/dashboard");
  };

  const orderHeaderAction = () => {
    return (
      <>
        <Tooltip title={"Export New Order"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Default Grid State"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDefaultGridState}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>material-outline:grid_on</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };

  const handleDialogCloseDesignerForm = () => {
    setOpenAssignerForm(false);
  };

  const handleSendDesigner = async () => {
    try {
      const selectedOrderIds = selectedRows.map((row) => row.id).join(",");
      const userMailId = assignedTo;
      await OAuthService.addData(
        `${baseUrl}/api/assignorders?orderIds=${selectedOrderIds}&userMailId=${encodeURIComponent(
          userMailId
        )}`
      );
      toast.success("Orders assigned to designer successfully.");
      setOpenAssignerForm(false);
      setSelectedRows([]);
      setAssignedTo(null);
      fetchOrders();
    } catch (error) {
      console.error("Assignment failed:", error);
      toast.error("Failed to assign designer. Please try again.");
      setOpenAssignerForm(false);
      setSelectedRows([]);
      setAssignedTo(null);
    }
  };

  const handleClear = () => {
    dispatch(clearStatusFilter());
    setFilter({ ...initialValues });
    setCreatedDateFrom(null);
    setCreatedDateTo(null);
    setProcessedDateFrom(null);
    setProcessedDateTo(null);
  };

  const searchHandler = () => {
    let updatedValues = {};
    for (const key in filter) {
      if (Object.hasOwnProperty.call(filter, key)) {
        updatedValues[key] = filter[key] === "ALL" ? "" : filter[key];
      }
    }
    const createdFromDateFormat = createdDateFrom === null ? null : moment(createdDateFrom).format("DD-MM-YYYY")
    const createdToDateFormat = createdDateTo === null ? null : moment(createdDateTo).format("DD-MM-YYYY")
    const processedFromDateFormat = processedDateFrom === null ? null : moment(processedDateFrom).format("DD-MM-YYYY")
    const processedToDateFormat = processedDateTo === null ? null : moment(processedDateTo).format("DD-MM-YYYY")

    const searchQuery = {
      ...updatedValues,
      createdFrom: createdFromDateFormat,
      createdTo: createdToDateFormat,
      processedFrom: processedFromDateFormat,
      processedTo: processedToDateFormat,
      status: orderStatus,
    }
    dispatch(setSavedStatus(searchQuery));
    dispatch(setHasFilter(true));
    setHasSearch(true);
  };

  useEffect(() => {
    if (hasSearch) {
      handleSearch();
    }
  }, [hasSearch]);

  const handleSearch = async () => {
    gridRef.current?.api?.showLoadingOverlay();
    try {
      const res = await OAuthService.getPostList(getNewOrderUrl, savedStatus);
      gridRef.current?.api?.hideOverlay();
      const filterUsers = res?.data?.orders.map((user) => user.createdByUser);
      setRowData(res?.data?.orders);
      setCreatedUser(filterUsers);
      setOrderCount(res?.data?.count);
      setHasSearch(false);
    } catch (error) {
      gridRef.current?.api?.hideOverlay();
      console.log(error.message);
      setError(error.message);
      setHasSearch(false);
    }
  };

  const handleCreatedDateFromChange = (date) => {
    const fromDate = date === null ? null : moment(date).format("YYYY-MM-DD 00:00:00")
    setCreatedDateFrom(fromDate);
    date && setCreatedDateTo(null);
  };
  const handleCreatedDateToChange = (date) => {
    const toDate = date === null ? null : moment(date).format("YYYY-MM-DD 23:59:59")
    setCreatedDateTo(toDate);
  };
  const handleProcessedDateFromChange = (date) => {
    const fromDate = date === null ? null : moment(date).format("YYYY-MM-DD 00:00:00")
    setProcessedDateFrom(fromDate);
    date && setProcessedDateTo(null)
  };
  const handleProcessedDateToChange = (date) => {
    const toDate =
      date === null ? null : moment(date).format("YYYY-MM-DD 23:59:59");
    setProcessedDateTo(toDate);
  };

  return (
    <>
      <FormPageHeader
        componentName="New Order List"
        pageName="New Order List"
        currentPage="New Order List"
        successMsg={successMsg}
        snackState={snackState}
        error={error}
        orderHeaderAction={orderHeaderAction()}
      >
        <div className="flex flex-col sm:flex sm:flex-row my-8 px-24">
          <Cards orderCount={orderCount} setOrderStatus={setOrderStatus} />
        </div>
        <Box className="flex px-16 sm:px-24 pt-4 flex-col" sx={{ pb: 1 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(8, 1fr)",
              },
              gap: 1.5,
              alignItems: "end",
            }}
          >
            <Box>
              <Select
                placeholder={"Customer"}
                name="customerId"
                value={
                  filter.customerId &&
                  customerOptions &&
                  customerOptions.filter(
                    (obj) => filter.customerId === obj.value,
                  )
                }
                options={customerOptions}
                onChange={(e) => handleSelectChange(e, "customerId")}
                styles={selectStyles}
                menuPortalTarget={document.body}
              />
            </Box>

            <Box>
              <Select
                placeholder={"Showroom"}
                name="showroomId"
                value={
                  filter.showroomId &&
                  showroomOptions &&
                  showroomOptions.filter(
                    (obj) => filter.showroomId === obj.value,
                  )
                }
                onChange={(e) => handleSelectChange(e, "showroomId")}
                options={showroomOptions}
                styles={selectStyles}
                menuPortalTarget={document.body}
              />
            </Box>

            <Box>
              <Select
                placeholder={"Created By"}
                name="createdBy"
                value={
                  filter.createdBy &&
                  userOptions &&
                  userOptions.filter((obj) => filter.createdBy === obj.value)
                }
                options={userOptions}
                onChange={(e) => handleSelectChange(e, "createdBy")}
                styles={selectStyles}
                menuPortalTarget={document.body}
                isClearable
              />
            </Box>

            <Box>
              <CustomDatePicker
                label="Created From"
                className={"w-full"}
                format={"dd-MM-yyyy"}
                name={"createdDateFrom"}
                value={createdDateFrom || ""}
                maxDate={createdDateTo && new Date(createdDateTo)}
                handleChange={handleCreatedDateFromChange}
                componentsProps={{ actionBar: { actions: ["clear"] } }}
              />
            </Box>

            <Box>
              <CustomDatePicker
                label="Created To"
                className={"w-full"}
                format={"dd-MM-yyyy"}
                name={"createdDateTo"}
                value={createdDateTo || ""}
                minDate={createdDateFrom && new Date(createdDateFrom)}
                handleChange={handleCreatedDateToChange}
                componentsProps={{ actionBar: { actions: ["clear"] } }}
              />
            </Box>

            <Box>
              <CustomDatePicker
                label="Processed From"
                className={"w-full"}
                format={"dd-MM-yyyy"}
                name={"processedDateFrom"}
                value={processedDateFrom || ""}
                maxDate={processedDateTo && new Date(processedDateTo)}
                handleChange={handleProcessedDateFromChange}
                componentsProps={{ actionBar: { actions: ["clear"] } }}
                disabled={orderStatus !== "COMPLETED"}
              />
            </Box>

            <Box>
              <CustomDatePicker
                label="Processed To"
                format={"dd-MM-yyyy"}
                className={"w-full"}
                name={"processedDateTo"}
                value={processedDateTo || ""}
                minDate={processedDateFrom && new Date(processedDateFrom)}
                handleChange={handleProcessedDateToChange}
                componentsProps={{ actionBar: { actions: ["clear"] } }}
                disabled={orderStatus !== "COMPLETED"}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Tooltip title="Search">
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ minWidth: "auto" }}
                  onClick={searchHandler}
                >
                  <FuseSvgIcon size={18}>material-solid:search</FuseSvgIcon>
                </Button>
              </Tooltip>
              <Tooltip title="Clear">
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ minWidth: "auto" }}
                  onClick={handleClear}
                >
                  <FuseSvgIcon size={18}>material-solid:clear_all</FuseSvgIcon>
                </Button>
              </Tooltip>
              <Tooltip title="Assign to Designer">
                <span>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ minWidth: "auto" }}
                    onClick={() => setOpenAssignerForm(true)}
                    disabled={selectedRows.length === 0}
                  >
                    <PersonAddAlt1Icon fontSize="small" />
                  </Button>
                </span>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </FormPageHeader>
      <div
        className={clsx(classes.root, "order-grid")}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          minHeight: 0,
          minWidth: 0,
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            minHeight: 400,
            minWidth: 0,
            width: "100%",
            height: isMobile ? "calc(100vh - 520px)" : "calc(100vh - 340px)",
            overflow: "hidden",
          }}
          className={`ag-theme-alpine${
            theme.palette.mode === "dark" ? "-dark" : ""
          }`}
        >
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowData={rowData}
            onGridReady={onGridReady}
            rowSelection="multiple"
            rowMultiSelectWithClick={true}
            rowGroupPanelShow="always"
            groupDisplayType="multipleColumns"
            onRowDoubleClicked={onRowDoubleClicked}
            onSelectionChanged={onSelectionChanged}
            autoGroupColumnDef={{
              headerName: "Group",
              minWidth: 200,
              cellRendererParams: { suppressCount: false, checkbox: false },
              pinned: isMobile ? false : "left",
            }}
            editable={false}
            rowHeight={isMobile ? 32 : 22}
            headerHeight={isMobile ? 36 : 30}
            onSortRefresh={onSortRefresh}
            getRowStyle={getRowStyle}
            onFirstDataRendered={onFirstDataRendered}
            onFilterChanged={onFilterChanged}
            onColumnMoved={onColumnStateChanged}
            onColumnPinned={onColumnStateChanged}
            onColumnVisible={onColumnStateChanged}
            onColumnResized={onColumnStateChanged}
            onColumnRowGroupChanged={onColumnGroupChange}
            suppressDragLeaveHidesColumns={true}
            cellSelection={true}
            suppressRowClickSelection={true}
          />
        </div>
      </div>
      <Dialog
        open={openAssignerForm}
        onClose={handleDialogCloseDesignerForm}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "400px",
            maxHeight: "90vh",
          },
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          position="static"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Designer Information
            </Typography>
            <IconButton onClick={handleDialogCloseDesignerForm} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Grid container spacing={2} mt={1}>
            <label className="mr-6 mb-4 text-md">
              Please select the Designer
            </label>
            <Select
              required
              options={user}
              styles={customStyles()}
              placeholder="Select Designer"
              value={user?.find((obj) => obj.value === assignedTo) || null}
              className="w-full mr-10"
              onChange={(e) => setAssignedTo(e ? e.value : null)}
              isClearable={true}
            />
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleDialogCloseDesignerForm}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendDesigner}
            color="secondary"
            variant="contained"
            disabled={!assignedTo}
          >
            Assign Designer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewOrderList;